"use client"

import { VStack } from "@chakra-ui/react"

import PageSkeleton from "@/components/PageSkeleton"
import Footer from "@/sections/Footer"
import SectionHero from "@/sections/Work/HeroWorkSection"
import MyArticles from "@/sections/Work/MyArticles"
import { Category, Skill, WebpageConfig } from "@/types/database"
import { Post } from "@/types/database"

interface WritingProps {
  posts: Post[]
  currentPage: number
  itemsPerPage: number
  totalItems: number
  totalPages: number
  webpage_config: WebpageConfig
  allTags?: Skill[]
  allCategories?: Category[]
  initialSelectedCategories?: string[]
  initialSelectedTags?: string[]
  initialSorting?: string
}

const Writing = ({
  allCategories,
  allTags,
  currentPage,
  initialSelectedCategories,
  initialSelectedTags,
  initialSorting,
  itemsPerPage,
  posts,
  totalPages,
  webpage_config,
}: WritingProps) => {
  return (
    <PageSkeleton name="work">
      <VStack
        alignItems="center"
        bgColor={"bg.paper"}
        gap={0}
        justifyContent={"flex-start"}
        width={"full"}
      >
        <VStack
          alignItems="center"
          className="writing"
          gap={0}
          minHeight={"calc(100vh - 104px)"}
          rounded={"0"}
          width={"full"}
        >
          <SectionHero
            heading={"Blog Articles ✍️"}
            preface={"Writing"}
            rightImg={`${webpage_config?.blog_hero_img?.id}`}
            subHeading={webpage_config?.blog_welcome_msg}
          />

          <MyArticles
            allCategories={allCategories ?? []}
            allTags={allTags ?? []}
            currentPage={currentPage}
            heading="My Articles 🗞️"
            initialSelectedCategories={initialSelectedCategories}
            initialSelectedTags={initialSelectedTags}
            initialSorting={initialSorting}
            itemsPerPage={itemsPerPage}
            postCardName="card11"
            posts={posts}
            totalPages={totalPages ?? 1}
            totalPosts={posts.length}
          />

          {/* <LetsTalk2 /> */}
          <Footer />
        </VStack>
      </VStack>
    </PageSkeleton>
  )
}

export default Writing
